/* global axios */
import ApiClient from './ApiClient';

// Painel Desempenho do menu Marketing. Usa o axios GLOBAL (com os headers de
// autenticação do dashboard) — o pacote npm 'axios' cru sai sem credencial e
// toma 401.
class MarketingAPI extends ApiClient {
  constructor() {
    super('marketing', { accountScoped: true });
  }

  performance(params) {
    return axios.get(`${this.url}/performance`, { params });
  }

  connections() {
    return axios.get(`${this.url}/connections`);
  }

  connectionsSync() {
    return axios.post(`${this.url}/connections/sync`);
  }

  googleConnectUrl() {
    return axios.post(`${this.url}/connections/google_connect_url`);
  }

  googleAdsInsights(params) {
    return axios.get(`${this.url}/google_ads/insights`, { params });
  }

  googleAdsBreakdowns(params) {
    return axios.get(`${this.url}/google_ads/breakdowns`, { params });
  }

  googleLeadImport() {
    return axios.get(`${this.url}/google_ads/lead_import`);
  }

  saveGoogleLeadImport(payload) {
    return axios.post(`${this.url}/google_ads/save_lead_import`, payload);
  }

  runGoogleLeadImport() {
    return axios.post(`${this.url}/google_ads/run_lead_import`);
  }
}

export default new MarketingAPI();
